// extracted by mini-css-extract-plugin
module.exports = {"container":"Project_container__3U-Jk","checked":"Project_checked__3b7QV"};